import React, {Fragment, useEffect, useState} from 'react'
import {Container, Row, Col, FormFeedback} from "reactstrap"
import _ from "lodash"
import {useForm} from "react-hook-form"
import classnames from "classnames"
import {useSelector} from 'react-redux'
//************************************//
import {trans} from "@utils"
import CustomFormGroup from "@src/components/helpers/CustomFormGroup"
import InputContainer from "@src/components/helpers/InputContainer"
import {_getAllStructures, _getStructureData} from "@cmodules/resources"
//************************************//
import LoadingIndicator from "@src/components/LoadingIndicator"
import {_getAllAssetTypes} from "../redux/actions"
//************************************//
const FormGroup = ({children}) => {
  return (
    <CustomFormGroup title={trans('asset.inputs.assetType')}>
      {children}
    </CustomFormGroup>
  )
}
//************************************//

const AssetTypeSelect = props => {
//************************************//
  const {useForm, name = "", defaultValue = null, typeIdDefaultValue = null, rules = {}, hideFormGroup = false, isDisabled} = props
  const {control, errors, trigger, register, setValue } = useForm
//************************************//
//************************************//
  const assetTypes = useSelector(store => store.asset.data.asset_types)
  const assetTypeOptions = _.map(assetTypes, x => ({label: x.name, value: x.uuid, id: x.id}))
//************************************//
  const getDefaultValue = () => {
    if (defaultValue) {
      return _.find(assetTypeOptions, x => x.value === defaultValue)
    }
    if (typeIdDefaultValue) {
      return _.find(assetTypeOptions, x => x.id === typeIdDefaultValue)
    }
    return ''
  }
//************************************//
  const InputWrapper = hideFormGroup ? Fragment : FormGroup
//************************************//
  return (
    <InputWrapper>
      <InputContainer
        control={control}
        type='select'
        options={assetTypeOptions}
        name={name}
        defaultValue={getDefaultValue()}
        className={classnames('react-select', {'is-invalid':_.get(errors, name)})}
        rules={rules}
        isDisabled={isDisabled}
      />
      {_.get(errors, name) && <FormFeedback>{_.get(errors, `${name}.message`)}</FormFeedback>}
    </InputWrapper>
  )
}

AssetTypeSelect.propTypes = {

}

export default AssetTypeSelect
